/**
 * External Dependencies
 */
import 'jquery';
import Splide from '@splidejs/splide';

function isTouchDevice() {
  return (('ontouchstart' in window) ||
     (navigator.maxTouchPoints > 0) ||
     (navigator.msMaxTouchPoints > 0));
}

jQuery(function() {

  function sticky()
    {
      var window_top=$(window).scrollTop();
      var top_position=$('body').offset().top + 20;
      var element_to_stick=$('.main-header');
      
      if (window_top > top_position) {
          element_to_stick.addClass('sticky-header');
      } else {
          element_to_stick.removeClass('sticky-header');
      }
  }
  $(window).on('scroll', sticky);
  sticky();

  if(isTouchDevice()) {
    $('body').addClass('touch-device');
  }

  $('.slider .splide').each(function (i, element) {
    new Splide(element, {
      type   : 'loop',
      lazyLoad: true,
      arrows: false,
      width: '100%',
      padding: {
        right: '0%',
      },
    }).mount();
  })

  $('.blog-slider .splide').each(function (i, element) {
    var splide = new Splide(element, {
      lazyLoad: true,
      pagination: false,
      perPage: 3,
      breakpoints: {
        768: {
          perPage: 1,
        },
        1280: {
          perPage: 2,
        },
      },
    });

    splide.on('mounted', function() {
      var list = element.querySelector('.splide__list');
      new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.attributeName === 'tabindex') {
            mutation.target.removeAttribute('tabindex');
          }
        });
      }).observe(list, { attributes: true, attributeFilter: ['tabindex'], subtree: true });

      $(element).find('.splide__slide').removeAttr('tabindex');
    });

    splide.mount();
  })

  $('.timeline .splide').each(function (i, element) {
    var splide = new Splide(element, {
      lazyLoad: true,
      perPage: 1,
      padding:  {
        left: '2rem',
        right: '10rem',
      },
      arrows: false,
      breakpoints: {
        1280: {
          padding:  {
            left: '0rem',
            right: '0rem',
          },
        },
      },
    });

    splide.on('mounted', function() {
      var dots = [];
      $(element).find('.ttl').each(function (i, dot) {
        dots.push($(dot).text())
      });
      $(element).find('.splide__pagination li').each(function (i, dot) {
        $(dot).append('<div class="xl:text-m">' + dots[i] + '</div>');
      });
    });

    splide.mount();
  })

  // Mobile menu toggle
  var $navToggle = $('#nav-toggle');
  var $navPrimary = $('#nav-primary');

  $navToggle.on('click', function () {
    var isOpen = $navPrimary.hasClass('nav-open');
    $navPrimary.toggleClass('nav-open', !isOpen);
    $navToggle.attr('aria-expanded', String(!isOpen));
    $navToggle.attr('aria-label', isOpen ? 'Menü öffnen' : 'Menü schließen');
  });

  $(document).on('keydown', function (e) {
    if (e.key === 'Escape' && $navPrimary.hasClass('nav-open')) {
      $navPrimary.removeClass('nav-open');
      $navToggle.attr('aria-expanded', 'false');
      $navToggle.attr('aria-label', 'Menü öffnen');
      $navToggle.trigger('focus');
    }
  });

})